module.exports = __webpack_public_path__ + "static/media/euan_lim.a43ff143.png";